let localStorage = window.localStorage
export const setLocalStorgeValue = (key, value) => {
  localStorage.setItem(key, value)
}
export const getLocalStorgeValue = (key) => {
  return localStorage.getItem(key)
}
export const removeLocalStorageValue = (key) => {
  return localStorage.removeItem(key)
}